/**
 * Auth Reducer
 * @author Dmitry Filyaev aka Fima
 */

import { SIGNIN, SIGNOUT } from '../constants';

const initialState = {
  isAuthenticated: false,
  role: null,
  user: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SIGNIN.SIGNIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
      };
    case SIGNOUT.SIGNOUT_SUCCESS:
      return {
        ...state,
        isAuthenticated: false,
      };
    default:
      return state;
  }
};
